const festivalData = {
  type: 'FeatureCollection',
  features: [
    ['Pukkelpop', 'Kiewit', 5.375, 50.965],
    ['Rock Werchter', 'Werchter', 4.703, 50.972],
    ['Sportpaleis', 'Antwerpen', 4.453, 51.229],
    ['Lotto Arena', 'Antwerpen', 4.454, 51.229],
    ['De Roma', 'Antwerpen', 4.441, 51.215],
    ['Trix', 'Antwerpen', 4.429, 51.231],
    ['Ancienne Belgique', 'Brussel', 4.347, 50.847],
    ['Flagey', 'Brussel', 4.373, 50.827],
    ['Vooruit', 'Gent', 3.724, 51.05],
    ['Muziekcentrum De Bijloke', 'Gent', 3.716, 51.047],
    ['Cactus Club', 'Brugge', 3.207, 51.196],
    ['Concertgebouw Brugge', 'Brugge', 3.216, 51.202],
    ['Het Depot', 'Leuven', 4.706, 50.877],
    ['Trixxo Theater', 'Hasselt', 5.348, 50.943],
  ].map(([name, municipality, longitude, latitude], index) => ({
    type: 'Feature',
    properties: {
      category: 'festival-or-venue',
      id: `venue:${index + 1}`,
      municipality,
      name,
    },
    geometry: { type: 'Point', coordinates: [longitude, latitude] },
  })),
};

export default festivalData;
